module.exports = __webpack_public_path__ + "images/RebrandedWebMainAreaHeroBackgroundDark-636f3fdd5f45b9fe8b8ff2dbe7bffd37.png";